import '../../../App.css';
import ContactUsComponent from '../Components/ContactUsComponent';
import Footer from '../Components/Static/Footer';
import HeaderBar from '../Components/Static/HeaderBar';
import {
  Typography,
  Container,
  Grid2,
  Box,
  Paper
} from '@mui/material';


// Notice we are NOT importing from 'react-native' anymore
export default function ContactUs() {
  return (
    <>
      <HeaderBar isLoggedIn={false} />
      <Box
        sx={{
          flexGrow: 0, // Make the main content take available space
          paddingTop: 2,
          margin: 0,
          backgroundColor: 'transparent',
        }}
      >
        <div style={{
          padding: '5px',
          paddingTop: '0',
          backgroundColor: 'transparent',
          maxWidth: '900px',
          margin: '0 auto',
          textAlign: 'left'
        }}>
          {/* Container for grid items */}
          <Container>
            <Grid2 item xs={12} md={4}>
              <Paper sx={{ marginBottom: 1, padding: 2, height: "100%" }}>
                {/* Typography content */}
                <Typography variant="h4" sx={{ marginTop: 2 }} style={{ textAlign: 'center' }}>
                  Contact Us
                </Typography>
              </Paper>
            </Grid2>
          </Container>

          <Container>
            <Grid2 item xs={12} md={4}>
              <Paper sx={{ marginBottom: 1, padding: 2, height: "100%" }}>
                <ContactUsComponent />
              </Paper>
            </Grid2>
          </Container>

        </div>
        <div style={{ position: 'fixed', width: "100%", left: 0, bottom: 0 }} >
          <Footer />
        </div>
      </Box>
    </>
  );
}